import toList, { authenticate, isAuthenticated } from "../utils/ComponentUtil";
import Checkbox from "../utils/Checkbox";
import CustomTextField from "../utils/CustomTextField";
import gmail from "../../images/login/gmail.png";
import Carousel from "../utils/Carousel";
import "./LoginPage.scss";
import CustomPasswordField from "../utils/CustomPasswordField";
import { Link } from 'react-router-dom';
import CustomForm from "../utils/Form";
import Navbar from "../navigation/Navbar";
import LoginAPI from "../Apis/LoginAPI";
import Footer from "../../components/app/Footer";
import { useState } from "react";

function LoginPage() {
  let path = window.location.pathname;
  let benefits = LoginAPI.fetchLoginBenefits();
  const [formData, setFormData] = useState({ email: '', password: '', remember: false });
  return (
    <>
    <Navbar></Navbar>
    <div className="login-page-wrp wrapper">
      <div className="explain-wrp">
        <div className="desc-wrp" >
          <Carousel numberOfCards={1} tabCards={1} arrows={false} showDots={true} cards={toList(benefits, undefined, (c, i) => {
            return <div className="desc-card" key={i}>
              <img className="desc-img" src={c.img} alt="desc-img" ></img>
              <div className="title">{c.title}</div>
              <div className="sub-title">{c.subTitle}</div>
            </div>
          }
          )}></Carousel>
        </div>
      </div>
      <div className="login-wrp">
        <div className="login-container-wrp">
          <div className="title">Login</div>
          <div className="login-btn-wrp">
          <Link reloadDocument={true} to='/login-with-google'>
            <div className="inner-container">
              <img className="gmail" src={gmail} alt="gmail" />
                <div className="text">Login With Gmail</div>
            </div>
            </Link>
          </div>
          <div className="divider">
            <div className="line"></div>
            <div className="Or">Or</div>
            <div className="line"></div>
          </div>
          <CustomForm
            onSubmit={(e, data) => authenticate(data.email, data.password, path)}
            formData={formData}
            render={(data, onChange) =>
              <>
                <div className="input-wrp">
                  <div className="label">E-Mail Id</div>
                  <CustomTextField name='email' type="email" helperText='* Incorrect Email id. Please enter correct Email id' required={true} className="input-box" value={data?.email} onChange={onChange} />
                </div>
                <div className="password-wrp">
                  <div className="label">Password</div>
                  <div className="pwd-input-wrp">
                    <CustomPasswordField name='password' className="masked-input" value={data?.password} onChange={onChange} />
                  </div>
                </div>
                <div className="forgot-pwd-wrp">
                  <div className="remember-wrp">
                    <Checkbox name='remember' checked={data?.remember} onChange={onChange} label={'Remember Password'}></Checkbox>
                  </div>
                  <div className="forgot-txt"><Link reloadDocument={true} to='/forgot-pwd'>Forgot Password ?</Link></div>
                </div>
                <div className="submit-wrp">
                  <button className="submit-btn" type="submit">
                    <div className="Login">Login</div>
                  </button>
                  <div className="msg">Don’t have an account? <Link reloadDocument={true} to='/signup'><span>Sign Up</span></Link></div>
                </div>
              </>
            }>
          </CustomForm>
        </div>
      </div>
    </div>
    <Footer/>
    </>
  );
}

export default LoginPage;
